const marker = {
  'priorityMarkers': {
    'id': 'priorityMarkers',
    'markersMap': {
      'priority-1': {
        'id': 'priority-1',
        'name': '%priority1',
        'resource': 'priority_1@32.png',
        'svg': 'priority_1@16.svg',
        'index': 0
      },
      'priority-2': {
        'id': 'priority-2',
        'name': '%priority2',
        'resource': 'priority_2@32.png',
        'svg': 'priority_2@16.svg',
        'index': 1
      },
      'priority-3': {
        'id': 'priority-3',
        'name': '%priority3',
        'resource': 'priority_3@32.png',
        'svg': 'priority_3@16.svg',
        'index': 2
      },
      'priority-4': {
        'id': 'priority-4',
        'name': '%priority4',
        'resource': 'priority_4@32.png',
        'svg': 'priority_4@16.svg',
        'index': 3
      },
      'priority-5': {
        'id': 'priority-5',
        'name': '%priority5',
        'resource': 'priority_5@32.png',
        'svg': 'priority_5@16.svg',
        'index': 4
      },
      'priority-6': {
        'id': 'priority-6',
        'name': '%priority6',
        'resource': 'priority_6@32.png',
        'svg': 'priority_6@16.svg',
        'index': 5
      },
      'priority-7': {
        'id': 'priority-7',
        'name': '%priority7',
        'resource': 'priority_7@32.png',
        'svg': 'priority_7@16.svg',
        'index': 6
      },
      'priority-8': {
        'id': 'priority-8',
        'name': '%priority8',
        'resource': 'priority_8@32.png',
        'svg': 'priority_8@16.svg',
        'hidden': 'true',
        'index': 7
      },
      'priority-9': {
        'id': 'priority-9',
        'name': '%priority9',
        'resource': 'priority_9@32.png',
        'svg': 'priority_9@16.svg',
        'hidden': 'true',
        'index': 8
      }
    }
  },
  'smileyMarkers': {
    'id': 'smileyMarkers',
    'markersMap': {
      'smiley-laugh': {
        'id': 'smiley-laugh',
        'name': '%smileyLaugh',
        'resource': 'emotion_laugh@32.png',
        'svg': 'emotion_laugh@16.svg',
        'index': 9
      },
      'smiley-smile': {
        'id': 'smiley-smile',
        'name': '%smileySmile',
        'resource': 'emotion_smile@32.png',
        'svg': 'emotion_smile@16.svg',
        'index': 10
      },
      'smiley-cry': {
        'id': 'smiley-cry',
        'name': '%smileyCry',
        'resource': 'emotion_cry@32.png',
        'svg': 'emotion_cry@16.svg',
        'index': 11
      },
      'smiley-surprise': {
        'id': 'smiley-surprise',
        'name': '%smileySurprise',
        'resource': 'emotion_surprise@32.png',
        'svg': 'emotion_surprise@16.svg',
        'index': 12
      },
      'smiley-boring': {
        'id': 'smiley-boring',
        'name': '%smileyBoring',
        'resource': 'emotion_boring@32.png',
        'svg': 'emotion_boring@16.svg',
        'index': 13
      },
      'smiley-angry': {
        'id': 'smiley-angry',
        'name': '%smileyAngry',
        'resource': 'emotion_angry@32.png',
        'svg': 'emotion_angry@16.svg',
        'index': 14
      },
      'smiley-embarrass': {
        'id': 'smiley-embarrass',
        'name': '%smileyEmbarrass',
        'resource': 'emotion_embarrass@16.png',
        'svg': 'emotion_embarrass@16.svg',
        'index': 15
      }
    }
  },
  'taskMakers': {
    'id': 'taskMakers',
    'markersMap': {
      'task-start': {
        'id': 'task-start',
        'name': '%taskStart',
        'resource': 'progress_start@32.png',
        'svg': 'progress_start@16.svg',
        'index': 16
      },
      'task-oct': {
        'id': 'task-oct',
        'name': '%taskOct',
        'resource': 'progress_1o@32.png',
        'svg': 'progress_1o@16.svg',
        'index': 17
      },
      'task-quarter': {
        'id': 'task-quarter',
        'name': '%taskQuarter',
        'resource': 'progress_1q@32.png',
        'svg': 'progress_1q@16.svg',
        'hidden': 'true',
        'index': 18
      },
      'task-3oct': {
        'id': 'task-3oct',
        'name': '%task3Oct',
        'resource': 'progress_3o@32.png',
        'svg': 'progress_3o@16.svg',
        'index': 19
      },
      'task-half': {
        'id': 'task-half',
        'name': '%taskHalf',
        'resource': 'progress_half@32.png',
        'svg': 'progress_half@16.svg',
        'index': 20
      },
      'task-5oct': {
        'id': 'task-5oct',
        'name': '%task5Oct',
        'resource': 'progress_5o@32.png',
        'svg': 'progress_5o@16.svg',
        'index': 21
      },
      'task-3quar': {
        'id': 'task-3quar',
        'name': '%task3Quarters',
        'resource': 'progress_3q@32.png',
        'svg': 'progress_3q@16.svg',
        'hidden': 'true',
        'index': 22
      },
      'task-7oct': {
        'id': 'task-7oct',
        'name': '%task7Oct',
        'resource': 'progress_7o@32.png',
        'svg': 'progress_7o@16.svg',
        'index': 23
      },
      'task-done': {
        'id': 'task-done',
        'name': '%taskDone',
        'resource': 'progress_done@32.png',
        'svg': 'progress_done@16.svg',
        'index': 24
      },
      'task-pause': {
        'id': 'task-pause',
        'name': '%taskPause',
        'resource': 'progress_pause@32.png',
        'hidden': 'true',
        'index': 25
      }
    }
  },
  'flagMakers': {
    'id': 'flagMakers',
    'markersMap': {
      'flag-red': {
        'id': 'flag-red',
        'name': '%colorRed',
        'resource': 'flag_red@32.png',
        'svg': 'flag_red@16.svg',
        'index': 26
      },
      'flag-orange': {
        'id': 'flag-orange',
        'name': '%colorOrange',
        'resource': 'flag_orange@32.png',
        'svg': 'flag_orange@16.svg',
        'index': 27
      },
      'flag-yellow': {
        'id': 'flag-yellow',
        'name': '%colorYellow',
        'resource': 'flag_yellow@32.png',
        'svg': 'flag_yellow@16.svg',
        'hidden': 'true',
        'index': 28
      },
      'flag-dark-blue': {
        'id': 'flag-dark-blue',
        'name': '%colorDarkBlue',
        'resource': 'flag_dark_blue@32.png',
        'svg': 'flag_dark_blue@16.svg',
        'index': 29
      },
      'flag-purple': {
        'id': 'flag-purple',
        'name': '%colorPurple',
        'resource': 'flag_purple@32.png',
        'svg': 'flag_purple@16.svg',
        'index': 30
      },
      'flag-green': {
        'id': 'flag-green',
        'name': '%colorGreen',
        'resource': 'flag_green@32.png',
        'svg': 'flag_green@16.svg',
        'index': 31
      },
      'flag-blue': {
        'id': 'flag-blue',
        'name': '%colorBlue',
        'resource': 'flag_blue@32.png',
        'svg': 'flag_blue@16.svg',
        'index': 32
      },
      'flag-gray': {
        'id': 'flag-gray',
        'name': '%colorGray',
        'resource': 'flag_gray@32.png',
        'svg': 'flag_gray@16.svg',
        'index': 33
      },
      'flag-dark-green': {
        'id': 'flag-dark-green',
        'name': '%colorDarkGreen',
        'resource': 'flag_dark_green@16.png',
        'svg': 'flag_dark_green@16.svg',
        'hidden': 'true',
        'index': 34
      },
      'flag-dark-gray': {
        'id': 'flag-dark-gray',
        'name': '%colorDarkGray',
        'resource': 'flag_dark_gray@16.png',
        'svg': 'flag_dark_gray@16.svg',
        'hidden': 'true',
        'index': 35
      }
    }
  },
  'starMakers': {
    'id': 'starMakers',
    'markersMap': {
      'star-red': {
        'id': 'star-red',
        'name': '%colorRed',
        'resource': 'star_red@32.png',
        'svg': 'star_red@16.svg',
        'index': 36
      },
      'star-orange': {
        'id': 'star-orange',
        'name': '%colorOrange',
        'resource': 'star_orange@32.png',
        'svg': 'star_orange@16.svg',
        'index': 37
      },
      'star-dark-blue': {
        'id': 'star-dark-blue',
        'name': '%colorDarkBlue',
        'resource': 'star_dark_blue@32.png',
        'svg': 'star_dark_blue@16.svg',
        'index': 38
      },
      'star-purple': {
        'id': 'star-purple',
        'name': '%colorPurple',
        'resource': 'star_purple@32.png',
        'svg': 'star_purple@16.svg',
        'index': 39
      },
      'star-green': {
        'id': 'star-green',
        'name': '%colorGreen',
        'resource': 'star_green@32.png',
        'svg': 'star_green@16.svg',
        'index': 40
      },
      'star-blue': {
        'id': 'star-blue',
        'name': '%colorBlue',
        'resource': 'star_blue@32.png',
        'svg': 'star_blue@16.svg',
        'index': 41
      },
      'star-gray': {
        'id': 'star-gray',
        'name': '%colorGray',
        'resource': 'star_gray@32.png',
        'svg': 'star_gray@16.svg',
        'index': 42
      },
      'star-yellow': {
        'id': 'star-yellow',
        'name': '%colorYellow',
        'resource': 'star_yellow@32.png',
        'svg': 'star_yellow@16.svg',
        'hidden': 'true',
        'index': 43
      },
      'star-dark-green': {
        'id': 'star-dark-green',
        'name': '%colorDarkGreen',
        'resource': 'star_dark_green@16.png',
        'svg': 'star_dark_green@16.svg',
        'hidden': 'true',
        'index': 44
      },
      'star-dark-gray': {
        'id': 'star-dark-gray',
        'name': '%colorDarkGray',
        'resource': 'star_dark_gray@16.png',
        'svg': 'star_dark_gray@16.svg',
        'hidden': 'true',
        'index': 45
      }
    }
  },
  'peopleMakers': {
    'id': 'peopleMakers',
    'markersMap': {
      'people-red': {
        'id': 'people-red',
        'name': '%colorRed',
        'resource': 'people_red@32.png',
        'svg': 'people_red@16.svg',
        'index': 46
      },
      'people-orange': {
        'id': 'people-orange',
        'name': '%colorOrange',
        'resource': 'people_orange@32.png',
        'svg': 'people_orange@16.svg',
        'index': 47
      },
      'people-yellow': {
        'id': 'people-yellow',
        'name': '%colorYellow',
        'resource': 'people_yellow@32.png',
        'svg': 'people_yellow@16.svg',
        'hidden': 'true',
        'index': 48
      },
      'people-dark-blue': {
        'id': 'people-dark-blue',
        'name': '%colorDarkBlue',
        'resource': 'people_dark_blue@32.png',
        'svg': 'people_dark_blue@16.svg',
        'index': 49
      },
      'people-purple': {
        'id': 'people-purple',
        'name': '%colorPurple',
        'resource': 'people_purple@32.png',
        'svg': 'people_purple@16.svg',
        'index': 50
      },
      'people-green': {
        'id': 'people-green',
        'name': '%colorGreen',
        'resource': 'people_green@32.png',
        'svg': 'people_green@16.svg',
        'index': 51
      },
      'people-blue': {
        'id': 'people-blue',
        'name': '%colorBlue',
        'resource': 'people_blue@32.png',
        'svg': 'people_blue@16.svg',
        'index': 52
      },
      'people-gray': {
        'id': 'people-gray',
        'name': '%colorGray',
        'resource': 'people_gray@32.png',
        'svg': 'people_gray@16.svg',
        'index': 53
      },
      'people-dark-green': {
        'id': 'people-dark-green',
        'name': '%colorDarkGreen',
        'resource': 'people_dark_green@16.png',
        'svg': 'people_dark_green@16.svg',
        'hidden': 'true',
        'index': 54
      },
      'people-dark-gray': {
        'id': 'people-dark-gray',
        'name': '%colorDarkGray',
        'resource': 'people_dark_gray@16.png',
        'svg': 'people_dark_gray@16.svg',
        'hidden': 'true',
        'index': 55
      }
    }
  },
  'arrowMakers': {
    'id': 'arrowMakers',
    'markersMap': {
      'arrow-left': {
        'id': 'arrow-left',
        'name': '%arrowLeft',
        'resource': 'arrow_left@32.png',
        'svg': 'arrow_left@16.svg',
        'index': 56
      },
      'arrow-right': {
        'id': 'arrow-right',
        'name': '%arrowRight',
        'resource': 'arrow_right@32.png',
        'svg': 'arrow_right@16.svg',
        'index': 57
      },
      'arrow-up': {
        'id': 'arrow-up',
        'name': '%arrowUp',
        'resource': 'arrow_up@32.png',
        'svg': 'arrow_up@16.svg',
        'index': 58
      },
      'arrow-down': {
        'id': 'arrow-down',
        'name': '%arrowDown',
        'resource': 'arrow_down@32.png',
        'svg': 'arrow_down@16.svg',
        'index': 59
      },
      'arrow-left-right': {
        'id': 'arrow-left-right',
        'name': '%arrowLeftRight',
        'resource': 'arrow_left_right@32.png',
        'svg': 'arrow_left_right@16.svg',
        'index': 60
      },
      'arrow-up-down': {
        'id': 'arrow-up-down',
        'name': '%arrowUpDown',
        'resource': 'arrow_up_down@32.png',
        'svg': 'arrow_up_down@16.svg',
        'index': 61
      },
      'arrow-refresh': {
        'id': 'arrow-refresh',
        'name': '%arrowRefresh',
        'resource': 'arrow_refresh@32.png',
        'svg': 'arrow_refresh@16.svg',
        'index': 62
      },
      'arrow-up-right': {
        'id': 'arrow-up-right',
        'name': '%arrowUpRight',
        'resource': 'arrow_up_right@32.png',
        'svg': 'arrow_up_right@16.svg',
        'hidden': 'true',
        'index': 63
      },
      'arrow-down-right': {
        'id': 'arrow-down-right',
        'name': '%arrowDownRight',
        'resource': 'arrow_down_right@32.png',
        'svg': 'arrow_down_right@16.svg',
        'hidden': 'true',
        'index': 64
      },
      'arrow-down-left': {
        'id': 'arrow-down-left',
        'name': '%arrowDownLeft',
        'resource': 'arrow_down_left@32.png',
        'svg': 'arrow_down_left@16.svg',
        'hidden': 'true',
        'index': 65
      },
      'arrow-up-left': {
        'id': 'arrow-up-left',
        'name': '%arrowUpLeft',
        'resource': 'arrow_up_left@32.png',
        'svg': 'arrow_up_left@16.svg',
        'hidden': 'true',
        'index': 66
      }
    }
  },
  'symbolMakers': {
    'id': 'symbolMakers',
    'markersMap': {
      'c_symbol_heart': {
        'id': 'c_symbol_heart',
        'name': '%symbolHeart',
        'resource': 'symbol_heart@16.png',
        'svg': 'symbol_heart.svg',
        'index': 67
      },
      'c_symbol_dislike': {
        'id': 'c_symbol_dislike',
        'name': '%symbolDislike',
        'resource': 'symbol_dislike@16.png',
        'svg': 'symbol_dislike.svg',
        'index': 68
      },
      'c_symbol_like': {
        'id': 'c_symbol_like',
        'name': '%symbolLike',
        'resource': 'symbol_like@16.png',
        'svg': 'symbol_like.svg',
        'index': 69
      },
      'c_symbol_music': {
        'id': 'c_symbol_music',
        'name': '%symbolMusic',
        'resource': 'symbol_music@16.png',
        'svg': 'symbol_music.svg',
        'index': 70
      },
      'c_symbol_lock': {
        'id': 'c_symbol_lock',
        'name': '%symbolLock',
        'svg': 'symbol_lock.svg',
        'index': 71
      },
      'c_symbol_hourglass': {
        'id': 'c_symbol_hourglass',
        'name': '%symbolHourglass',
        'svg': 'symbol_hourglass.svg',
        'index': 72
      },
      'c_symbol_broken_heart': {
        'id': 'c_symbol_broken_heart',
        'name': '%symbolBrokenHeart',
        'svg': 'symbol_broken_heart.svg',
        'index': 73
      },
      'c_symbol_quote': {
        'id': 'c_symbol_quote',
        'name': '%symbolQuote',
        'svg': 'symbol_quote.svg',
        'index': 74
      },
      'c_symbol_apostrophe': {
        'id': 'c_symbol_apostrophe',
        'name': '%symbolApostrophe',
        'svg': 'symbol_apostrophe.svg',
        'index': 75
      },
      'symbol-question': {
        'id': 'symbol-question',
        'name': '%symbolQuestion',
        'resource': 'symbol_question@32.png',
        'svg': 'symbol_question@16.svg',
        'index': 76
      },
      'symbol-attention': {
        'id': 'symbol-attention',
        'name': '%symbolAttention',
        'resource': 'symbol_attention.png',
        'svg': 'symbol_attention@16.svg',
        'index': 77
      },
      'symbol-wrong': {
        'id': 'symbol-wrong',
        'name': '%symbolWrong',
        'resource': 'symbol_wrong@32.png',
        'svg': 'symbol_wrong@16.svg',
        'index': 78
      },
      'symbol-pause': {
        'id': 'symbol-pause',
        'name': '%symbolPause',
        'resource': 'symbol_pause@32.png',
        'svg': 'symbol_pause@16.svg',
        'index': 79
      },
      'symbol-no-entry': {
        'id': 'symbol-no-entry',
        'name': '%symbolNoEntry',
        'svg': 'symbol_no_entry@16.svg',
        'index': 80
      },
      'symbol-plus': {
        'id': 'symbol-plus',
        'name': '%symbolPlus',
        'resource': 'symbol_plus@32.png',
        'svg': 'symbol_plus@16.svg',
        'index': 81
      },
      'symbol-minus': {
        'id': 'symbol-minus',
        'name': '%symbolMinus',
        'resource': 'symbol_minus@32.png',
        'svg': 'symbol_minus@16.svg',
        'index': 82
      },
      'symbol-info': {
        'id': 'symbol-info',
        'name': '%symbolInfo',
        'resource': 'symbol_information@32.png',
        'svg': 'symbol_information@16.svg',
        'index': 83
      },
      'symbol-divide': {
        'id': 'symbol-divide',
        'name': '%symbolDivide',
        'svg': 'symbol_divide@16.svg',
        'index': 84
      },
      'symbol-equality': {
        'id': 'symbol-equality',
        'name': '%symbolEquality',
        'svg': 'symbol_equality@16.svg',
        'index': 85
      },
      'symbol-right': {
        'id': 'symbol-right',
        'name': '%symbolRight',
        'resource': 'symbol_right@32.png',
        'svg': 'symbol_right@16.svg',
        'index': 86
      },
      'symbol-code': {
        'id': 'symbol-code',
        'name': '%symbolCode',
        'svg': 'symbol_code@16.svg',
        'index': 87
      },
      'c_symbol_contact': {
        'id': 'c_symbol_contact',
        'name': '%symbolContact',
        'resource': 'symbol_contact@16.png',
        'svg': 'symbol_contact.svg',
        'index': 88
      },
      'c_symbol_telephone': {
        'id': 'c_symbol_telephone',
        'name': '%symbolTelephone',
        'resource': 'symbol_telephone@16.png',
        'svg': 'symbol_telephone.svg',
        'index': 89
      },
      'c_symbol_pen': {
        'id': 'c_symbol_pen',
        'name': '%symbolPen',
        'resource': 'symbol_pen@16.png',
        'svg': 'symbol_pen.svg',
        'index': 90
      },
      'c_symbol_money': {
        'id': 'c_symbol_money',
        'name': '%symbolMoney',
        'resource': 'symbol_money@16.png',
        'svg': 'symbol_money.svg',
        'index': 91
      },
      'c_symbol_bar_chart': {
        'id': 'c_symbol_bar_chart',
        'name': '%symbolBarChart',
        'resource': 'symbol_bar_chart@16.png',
        'svg': 'symbol_bar_chart.svg',
        'index': 92
      },
      'c_symbol_pie_chart': {
        'id': 'c_symbol_pie_chart',
        'name': '%symbolPieChart',
        'resource': 'symbol_pie_chart@16.png',
        'svg': 'symbol_pie_chart.svg',
        'index': 93
      },
      'c_symbol_line_graph': {
        'id': 'c_symbol_line_graph',
        'name': '%symbolLineGraph',
        'resource': 'symbol_line_graph@16.png',
        'svg': 'symbol_line_graph.svg',
        'index': 94
      },
      'c_symbol_shopping_cart': {
        'id': 'c_symbol_shopping_cart',
        'name': '%symbolShoppingCart',
        'resource': 'symbol_shopping_cart@16.png',
        'svg': 'symbol_shopping_cart.svg',
        'index': 95
      },
      'c_symbol_medals': {
        'id': 'c_symbol_medals',
        'name': '%symbolMedals',
        'resource': 'symbol_medals@16.png',
        'svg': 'symbol_medals.svg',
        'index': 96
      },
      'c_symbol_trophy': {
        'id': 'c_symbol_trophy',
        'name': '%symbolTrophy',
        'resource': 'symbol_trophy@16.png',
        'svg': 'symbol_trophy.svg',
        'index': 97
      },
      'symbol-image': {
        'id': 'symbol-image',
        'name': '%symbolImage',
        'svg': 'symbol_image@16.svg',
        'index': 98
      },
      'c_symbol_exercise': {
        'id': 'c_symbol_exercise',
        'name': '%symbolExercise',
        'resource': 'symbol_exercise@16.png',
        'svg': 'symbol_exercise.svg',
        'index': 99
      },
      'c_symbol_flight': {
        'id': 'c_symbol_flight',
        'name': '%symbolFlight',
        'resource': 'symbol_flight@16.png',
        'svg': 'symbol_flight.svg',
        'index': 100
      },
      'symbol-pin': {
        'id': 'symbol-pin',
        'name': '%symbolPin',
        'svg': 'symbol_pin@16.svg',
        'index': 101
      },
      'symbol-exclam': {
        'id': 'symbol-exclam',
        'name': '%symbolExclam',
        'resource': 'symbol_exclamation@32.png',
        'svg': 'symbol_exclamation@16.svg',
        'index': 102,
        'hidden': 'true'
      },
      'c_simbol-plus': {
        'id': 'c_simbol-plus',
        'name': '%symbolPlus',
        'resource': 'c_simbol_plus@32.png',
        'svg': 'symbol_plus@16.svg',
        'index': 103,
        'hidden': 'true'
      },
      'c_simbol-minus': {
        'id': 'c_simbol-minus',
        'name': '%symbolMinus',
        'resource': 'c_simbol_minus@32.png',
        'svg': 'symbol_minus@16.svg',
        'index': 104,
        'hidden': 'true'
      },
      'c_simbol-question': {
        'id': 'c_simbol-question',
        'name': '%symbolQuestion',
        'resource': 'c_simbol_question@32.png',
        'svg': 'c_simbol_question@16.svg',
        'index': 105,
        'hidden': 'true'
      },
      'c_simbol-exclam': {
        'id': 'c_simbol-exclam',
        'name': '%symbolExclam',
        'resource': 'c_simbol_exclamation@32.png',
        'svg': 'c_simbol_exclamation@16.svg',
        'index': 106,
        'hidden': 'true'
      },
      'c_simbol-info': {
        'id': 'c_simbol-info',
        'name': '%symbolInfo',
        'resource': 'c_simbol_information@32.png',
        'svg': 'symbol_information@16.svg',
        'index': 107,
        'hidden': 'true'
      },
      'c_simbol-wrong': {
        'id': 'c_simbol-wrong',
        'name': '%symbolWrong',
        'resource': 'c_simbol_wrong@32.png',
        'svg': 'c_simbol_wrong@16.svg',
        'index': 108,
        'hidden': 'true'
      },
      'c_simbol-right': {
        'id': 'c_simbol-right',
        'name': '%symbolRight',
        'resource': 'c_simbol_right@32.png',
        'svg': 'symbol_right@16.svg',
        'index': 109,
        'hidden': 'true'
      },
      'c_simbol-pause': {
        'id': 'c_simbol-pause',
        'name': '%symbolPause',
        'resource': 'c_simbol_pause@32.png',
        'svg': 'symbol_pause@16.svg',
        'index': 110,
        'hidden': 'true'
      },
      'c_symbol_thermometer': {
        'id': 'c_symbol_thermometer',
        'name': '%symbolThermometer',
        'resource': 'symbol_thermometer@16.png',
        'svg': 'symbol_thermometer.svg',
        'index': 111,
        'hidden': 'true'
      }
    }
  },
  'monthMakers': {
    'id': 'monthMakers',
    'markersMap': {
      'month-jan': {
        'id': 'month-jan',
        'name': '%monthJan',
        'resource': 'month_jan@32.png',
        'svg': 'month_jan@16.svg',
        'index': 112
      },
      'month-feb': {
        'id': 'month-feb',
        'name': '%monthFeb',
        'resource': 'month_feb@32.png',
        'svg': 'month_feb@16.svg',
        'index': 113
      },
      'month-mar': {
        'id': 'month-mar',
        'name': '%monthMar',
        'resource': 'month_mar@32.png',
        'svg': 'month_mar@16.svg',
        'index': 114
      },
      'month-apr': {
        'id': 'month-apr',
        'name': '%monthApr',
        'resource': 'month_apr@32.png',
        'svg': 'month_apr@16.svg',
        'index': 115
      },
      'month-may': {
        'id': 'month-may',
        'name': '%monthMay',
        'resource': 'month_may@32.png',
        'svg': 'month_may@16.svg',
        'index': 116
      },
      'month-jun': {
        'id': 'month-jun',
        'name': '%monthJun',
        'resource': 'month_jun@32.png',
        'svg': 'month_jun@16.svg',
        'index': 117
      },
      'month-jul': {
        'id': 'month-jul',
        'name': '%monthJul',
        'resource': 'month_jul@32.png',
        'svg': 'month_jul@16.svg',
        'index': 118
      },
      'month-aug': {
        'id': 'month-aug',
        'name': '%monthAug',
        'resource': 'month_aug@32.png',
        'svg': 'month_aug@16.svg',
        'index': 119
      },
      'month-sep': {
        'id': 'month-sep',
        'name': '%monthSep',
        'resource': 'month_sep@32.png',
        'svg': 'month_sep@16.svg',
        'index': 120
      },
      'month-oct': {
        'id': 'month-oct',
        'name': '%monthOct',
        'resource': 'month_oct@32.png',
        'svg': 'month_oct@16.svg',
        'index': 121
      },
      'month-nov': {
        'id': 'month-nov',
        'name': '%monthNov',
        'resource': 'month_nov@32.png',
        'svg': 'month_nov@16.svg',
        'index': 122
      },
      'month-dec': {
        'id': 'month-dec',
        'name': '%monthDec',
        'resource': 'month_dec@32.png',
        'svg': 'month_dec@16.svg',
        'index': 123
      }
    }
  },
  'weekMakers': {
    'id': 'weekMakers',
    'markersMap': {
      'week-sun': {
        'id': 'week-sun',
        'name': '%weekSun',
        'resource': 'week_sun@32.png',
        'svg': 'week_sun@16.svg',
        'index': 124
      },
      'week-mon': {
        'id': 'week-mon',
        'name': '%weekMon',
        'resource': 'week_mon@32.png',
        'svg': 'week_mon@16.svg',
        'index': 125
      },
      'week-tue': {
        'id': 'week-tue',
        'name': '%weekTue',
        'resource': 'week_tue@32.png',
        'svg': 'week_tue@16.svg',
        'index': 126
      },
      'week-wed': {
        'id': 'week-wed',
        'name': '%weekWed',
        'resource': 'week_wed@32.png',
        'svg': 'week_wed@16.svg',
        'index': 127
      },
      'week-thu': {
        'id': 'week-thu',
        'name': '%weekThu',
        'resource': 'week_thu@32.png',
        'svg': 'week_thu@16.svg',
        'index': 128
      },
      'week-fri': {
        'id': 'week-fri',
        'name': '%weekFri',
        'resource': 'week_fri@32.png',
        'svg': 'week_fri@16.svg',
        'index': 129
      },
      'week-sat': {
        'id': 'week-sat',
        'name': '%weekSat',
        'resource': 'week_sat@32.png',
        'svg': 'week_sat@16.svg',
        'index': 130
      }
    }
  },
  'halfStarMarkers': {
    'id': 'halfStarMarkers',
    'hidden': 'true',
    'markersMap': {
      'half-star-green': {
        'id': 'half-star-green',
        'name': '%colorGreen',
        'resource': 'star_green_half.png',
        'index': 131
      },
      'half-star-red': {
        'id': 'half-star-red',
        'name': '%colorRed',
        'resource': 'star_red_half.png',
        'index': 132
      },
      'half-star-yellow': {
        'id': 'half-star-yellow',
        'name': '%colorYellow',
        'resource': 'star_yellow_half.png',
        'index': 133
      },
      'half-star-purple': {
        'id': 'half-star-purple',
        'name': '%colorPurple',
        'resource': 'star_purple_half.png',
        'index': 134
      },
      'half-star-blue': {
        'id': 'half-star-blue',
        'name': '%colorBlue',
        'resource': 'star_blue_half.png',
        'index': 135
      },
      'half-star-gray': {
        'id': 'half-star-gray',
        'name': '%colorGray',
        'resource': 'star_gray_half.png',
        'index': 136
      }
    }
  },
  'otherMarkers': {
    'id': 'otherMarkers',
    'hidden': 'true',
    'markersMap': {
      'other-calendar': {
        'id': 'other-calendar',
        'name': '%otherCalendar',
        'resource': 'other_calendar.png',
        'index': 137
      },
      'other-email': {
        'id': 'other-email',
        'name': '%otherEmail',
        'resource': 'other_email.png',
        'index': 138
      },
      'other-phone': {
        'id': 'other-phone',
        'name': '%otherPhone',
        'resource': 'other_phone.png',
        'index': 139
      },
      'other-phone2': {
        'id': 'other-phone2',
        'name': '%otherPhone',
        'resource': 'other_phone2.png',
        'index': 140
      },
      'other-fax': {
        'id': 'other-fax',
        'name': '%otherFax',
        'resource': 'other_print.png',
        'index': 141
      },
      'other-people': {
        'id': 'other-people',
        'name': '%otherPeople',
        'resource': 'people_green@32.png',
        'index': 142
      },
      'other-people2': {
        'id': 'other-people2',
        'name': '%otherPeople',
        'resource': 'people_blue@32.png',
        'index': 143
      },
      'other-clock': {
        'id': 'other-clock',
        'name': '%otherClock',
        'resource': 'other_clock.png',
        'index': 144
      },
      'other-coffee-cup': {
        'id': 'other-coffee-cup',
        'name': '%otherCoffeeCup',
        'resource': 'other_coffee.png',
        'index': 145
      },
      'other-question': {
        'id': 'other-question',
        'name': '%otherQuestion',
        'resource': 'symbol_question@32.png',
        'svg': 'symbol_question@16.svg',
        'index': 146
      },
      'other-exclam': {
        'id': 'other-exclam',
        'name': '%otherExclam',
        'resource': 'symbol_exclamation@32.png',
        'svg': 'symbol_exclamation@16.svg',
        'index': 147
      },
      'other-lightbulb': {
        'id': 'other-lightbulb',
        'name': '%otherLightBulb',
        'resource': 'other_buble.png',
        'index': 148
      },
      'other-businesscard': {
        'id': 'other-businesscard',
        'name': '%otherBusinessCard',
        'resource': 'other_businesscard.png',
        'index': 149
      },
      'other-social': {
        'id': 'other-social',
        'name': '%otherSocial',
        'resource': 'other_social.png',
        'index': 150
      },
      'other-chat': {
        'id': 'other-chat',
        'name': '%otherChat',
        'resource': 'other_chat.png',
        'index': 151
      },
      'other-note': {
        'id': 'other-note',
        'name': '%otherNote',
        'resource': 'other_note.png',
        'index': 152
      },
      'other-lock': {
        'id': 'other-lock',
        'name': '%otherLock',
        'resource': 'other_lock.png',
        'index': 153
      },
      'other-unlock': {
        'id': 'other-unlock',
        'name': '%otherUnlock',
        'resource': 'other_unlock.png',
        'index': 154
      },
      'other-yes': {
        'id': 'other-yes',
        'name': '%otherYes',
        'resource': 'symbol_right@32.png',
        'svg': 'symbol_right@16.svg',
        'index': 155
      },
      'other-no': {
        'id': 'other-no',
        'name': '%otherNo',
        'resource': 'symbol_wrong@32.png',
        'svg': 'symbol_wrong@16.svg',
        'index': 156
      },
      'other-bomb': {
        'id': 'other-bomb',
        'name': '%otherBomb',
        'resource': 'other_bomb.png',
        'index': 157
      }
    }
  }
};

const icons = {};
const iterable = {};

for(const key in marker) {
  const realGroupId = key;
  const map = marker[key].markersMap;
  
  for(const markerId in map) {
    if (!map.hasOwnProperty(markerId)) continue;
    if (markerId.startsWith('c_')) continue;
    const arr = markerId.split('-');
    const collection = arr[0];
    const name = arr.length > 2 ? arr.slice(1, arr.length).join('-') : arr[1];

    if (!iterable[collection]) {
      iterable[collection] = [];
    }

    if (!icons[collection]) {
      icons[collection] = {};
    }

    iterable[collection].push(name);
    icons[collection][name] = { groupId: realGroupId, markerId: markerId };
  }
}

export { icons, iterable };